<template>
  <div v-if="customPage">
    <banner-part
      :banner-heading="_T_DB(customPage, 'banner_heading')"
      :banner-text="_T_DB(customPage, 'banner_text')"
      :banner-image="customPage.banner_image"
    />
    <content-part
      :content-heading="_T_DB(customPage, 'content_heading')"
      :content-text="_T_DB(customPage, 'content')"
      :content-image="customPage.content_image"
    />
    <values-part :blocks="customPage.extra_blocks" />
  </div>
</template>

<script>
import BannerPart from './components/BannerPart'
import ContentPart from './components/ContentPart'
import ValuesPart from './components/ValuesPart'
import { mapGetters } from 'vuex'

export default {
  name: 'StaticCustomPage',
  components: {
    BannerPart,
    ContentPart,
    ValuesPart,
  },
  props: ['pageSlug'],
  computed: {
    ...mapGetters(['_T_DB', 'all_static_pages']),
    customPage() {
      let pSlug = this.$route.params.page_slug
      if (this.all_static_pages) {
        return this.all_static_pages.find(
          page => page.slug === pSlug
        )
      }
      return {}
    },
  },
}
</script>

<style lang="scss">
.trending-blog {
  .blog-title {
      h2 {
          text-align: center;
          text-transform: capitalize;
          line-height: $px39;
          letter-spacing: 0.7px;
          color: $font-color;
          padding-bottom: calc(#{$px15} + (42 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
          margin-bottom: calc(#{$px25} + (74 - 25) * ((100vw - #{$px320}) / (1920 - 320)));
          position: relative;
          &::after {
              position: absolute;
              content: '';
              bottom: 0;
              left: 0;
              right: 0;
              margin: 0 auto;
              width: $px90;
              height: $px5;
              background-color: $color-tertiary;
          }
      }
  }
}
</style>

